import React from 'react'
import {Icon, Tabs} from '@therms/atalaya'
import {useLocationContext, useTabsState} from '@therms/react-modules'
import {CheckpointsTab} from './CheckpointsTab'
import {EntriesTab} from './EntriesTab'
import {MdRoute} from 'react-icons/md'

function LocationLogs() {
  const {location, locationId} = useLocationContext(true)

  const [tab, setTab] = useTabsState(
    `${locationId || location?.id}_logtb`,
    'Entries',
  )

  if (!location?.settings.modules?.checkpoints) return <EntriesTab />

  return (
    <div className="relative">
      <Tabs initialTabKey={tab} fullWidth onTabClick={setTab} pills>
        <Tabs.Tab title="Entries">
          <EntriesTab />
        </Tabs.Tab>

        <Tabs.Tab title="Checkpoints" icon={<Icon Icon={MdRoute} />}>
          <CheckpointsTab />
        </Tabs.Tab>
      </Tabs>
    </div>
  )
}

export {LocationLogs}
